import { Colors } from '@inplayer-org/inplayer-ui';
import { transparentize } from 'polished';

export const customStyles = {
  control: (provided: any, state: any) => ({
    ...provided,
    borderColor: state.isFocused ? Colors.skyBlue : Colors.gray,
    boxShadow: 'none',
    '&:hover': {
      borderColor: Colors.skyBlue,
      boxShadow: 'none',
    },
  }),
  // menuPortal is needed to prevent the select options dropdown to go under the modal
  menuPortal: (provided: any) => ({
    ...provided,
    zIndex: 9999,
  }),
  multiValue: (provided: any) => ({
    ...provided,
    borderRadius: '3px',
    background: transparentize(0.8, Colors.lightSkyBlue),
    border: `1px solid ${Colors.skyBlue}`,
  }),
  multiValueLabel: (provided: any) => ({
    ...provided,
    color: Colors.skyBlue,
  }),
  multiValueRemove: (provided: any) => ({
    ...provided,
    color: Colors.skyBlue,
    '&:hover': {
      background: 'none',
    },
  }),
};
